import React from "react"

import {$getNodeByKey, LexicalEditor} from "lexical"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {$isCodeNode} from "@lexical/code"
import {NodeKey} from "lexical/LexicalNode"
import VScroll from "../../../../../scrolling/custom-v-scroll/v-scroll"

type Props = {
    menuParams: {
        options             : any[]
        editor              : LexicalEditor
        selectedElementKey  : NodeKey | null
        codeLanguage        : any
    }
    hidePopover : callback
}

const debug = false
// const debug = "ToolbarCodeLanguageMenu"

export default function ToolbarCodeLanguageMenu(props:Props) {

    const onClick = (value:any):void => {
        props.hidePopover()

        props.menuParams.editor.update(() => {
            if (props.menuParams.selectedElementKey !== null) {
                const node = $getNodeByKey(props.menuParams.selectedElementKey);
                if ($isCodeNode(node)) {
                    node.setLanguage(value)
                }
            }
        })
    }

    return (
        <VScroll containerStyle={{maxHeight: 200}}>
            <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
                {_.map(props.menuParams.options, (option:any, index:number)=>
                    <PopoverMenuOption key      = {option.value}
                                       option   = {option}
                                       onClick  = {()=>onClick(option.value)}/>
                )}
            </div>
        </VScroll>

    )
}